module.exports = __webpack_public_path__ + "img/payments_illustration.7e087d4d.svg";